<template>
  <div class="az-form-content">
    <v-container :key="componentKey" fluid grid-list-xl>
      <v-layout wrap align-center>
        <v-flex xs12 sm3 d-flex>
          <div class="az-text dados-edital-numero-edital">
            <label>Número do Edital</label>
            <p>{{ value.numeroEdital }}</p>
          </div>
        </v-flex>
        <v-flex xs12 sm12 d-flex v-if="anexos.length > 0">
          <span class="az-subtitle primary--text">Anexos do Edital</span>
        </v-flex>
        <v-flex xs12 sm12 d-flex v-if="editando">
          <edl-file-upload :accept="arquivosAceitos" :repository="repository" ref="azFileUploadEdital"
                           v-show="editando">
            <a @click.prevent="$refs.azFileUploadEdital.openFileSelector()">
              <v-icon>archive</v-icon>
              Importar Arquivos
            </a>
            <p>Arraste e solte os arquivos aqui para serem carregados.</p>
          </edl-file-upload>
        </v-flex>
        <v-flex xs12 sm12 d-flex>
          <v-data-table v-if="anexos.length > 0"
                        :headers="colunasTabela"
                        :items="anexos"
                        :loading="false"
                        hide-actions
                        class="az-table-list table-dados-edital"
          >
            <template slot="items" slot-scope="props">
              <tr>
                <td class="table-status__error coluna-documento-edital">
                  <div style="display: inline-flex; width: 30px;">
                    <v-tooltip top v-if="!props.item.tipo">
                      <v-icon class="pa-0" slot="activator">error_outline</v-icon>
                      <span>Informe o tipo do anexo</span>
                    </v-tooltip>
                    <v-tooltip top v-if="!isAceitoPNCP(props.item)">
                      <v-icon class="ml-1 pa-0" slot="activator">warning_outline</v-icon>
                      <span>Este anexo não será enviado para o PNCP pois o formato não é aceito</span>
                    </v-tooltip>
                  </div>
                </td>
                <td class="coluna-documento-edital">
                  <span v-if="props.item.relatorioNome">{{ props.item.relatorioNome }}</span>
                  <span v-else-if="props.item.tipo">{{ props.item.tipo | tipoAnexo }}</span>
                  <span v-else>--</span>
                </td>
                <td class="coluna-documento-edital">
                  <v-select v-if="isSelectTipoHabilitado(props.item)"
                            :items="tiposAnexo.filter(tipo=>!tipo.oculto)"
                            v-model="props.item.tipo"
                            item-text="label"
                            item-value="chave" align="center"
                  >
                  </v-select>
                  <span v-else>{{ props.item.tipo | tipoAnexo }}</span>
                </td>
                <td class="coluna-documento-edital">
                  <span>{{ props.item.dataCadastro | az-date('DD/MM/YYYY HH:mm') }}</span>
                </td>
                <td class="coluna-documento-edital">{{ props.item.arquivoNome }}</td>
                <td class="coluna-documento-edital">{{ retornaDescricaoSituacaoAnexo(props.item.situacao) }}</td>
                <td class="table-actions">
                  <div>
                    <a @click="baixarArquivo(props.item)" v-if="props.item.id" title="Download do Anexo"
                       target="_blank" class="az-action-link-icon">
                      <v-icon>get_app</v-icon>
                    </a>
                    <v-tooltip top>
                      <a slot="activator" @click.prevent="emitirInativarAnexo(props.item)"
                         v-if="editando && props.item.situacao === 'ATIVO'" title="Inativar Anexo">
                        <v-icon :class="anexoEstaBloqueado(props.item) ? 'desativado' : '' ">visibility_off</v-icon>
                      </a>
                      <span v-if="anexoEstaBloqueado(props.item)">Aguarde</span>
                      <span v-else>Inativar</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <a slot="activator" @click.prevent="emitirAtivarAnexo(props.item)"
                         v-if="editando && props.item.situacao === 'INATIVO'" title="Ativar Anexo">
                        <v-icon :class="anexoEstaBloqueado(props.item) ? 'desativado' : '' ">visibility</v-icon>
                      </a>
                      <span v-if="anexoEstaBloqueado(props.item)">Aguarde</span>
                      <span v-else>Ativar</span>
                    </v-tooltip>
                    <a @click.prevent="$emit('onRemoverAnexo', props.item)"
                       v-if="editando && (value.publicado === false || value.publicado === null)" title="Remover Anexo">
                      <v-icon>close</v-icon>
                    </a>
                  </div>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
        <v-flex xs12 sm12 d-flex v-if="!anexos.length && !editando">
          <az-ops title="Ops! Nenhum anexo encontrado."
                  message="Utilize o botão importar com a tela em modo de edição para adicionar anexos"
          ></az-ops>
        </v-flex>
      </v-layout>

      <div class="rodape-espaco"></div>
    </v-container>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import {actionTypes, tiposAnexo, formatosAceitosPncp} from '@/commons/constants'
import {AzSoundex} from '@azinformatica/loki'
import EdlFileUpload from "@/commons/components/file/EdlFileUpload.vue";

export default {
  name: 'DadosEdital',
  components: {EdlFileUpload},
  inject: ['$validator'],
  props: {
    editando: {
      type: Boolean,
      default: false
    },
    value: {
      required: true
    },
    anexosBloqueadosAtivarInativar: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      colunasTabela: [
        {
          text: '',
          align: 'left',
          sortable: false,
          width: '30px'
        },
        {
          text: 'Relatório',
          align: 'left',
          sortable: false,
          width: '250px',
          class: 'primary--text'
        },
        {
          text: 'Tipo',
          align: 'left',
          sortable: false,
          width: '250px',
          class: 'primary--text'
        },
        {
          text: 'Data',
          align: 'left',
          sortable: false,
          width: '150px',
          class: 'primary--text'
        },
        {
          text: 'Nome',
          sortable: false,
          align: 'left',
          class: 'primary--text'
        },
        {
          text: 'Situação',
          sortable: false,
          align: 'left',
          class: 'primary--text'
        },
        {
          text: 'Ações',
          sortable: false,
          align: 'center',
          width: '120px',
          class: 'primary--text'
        }
      ],
      licitacaoId: undefined,
      repository: 'repo1:licitacao',
      soundexTiposAnexo: [],
      taxaSemelhancaMinimaAceitavelTipoAnexo: 0.5,
      tiposAnexo,
      componentKey: 0
    }
  },
  computed: {
    anexos() {
      const anexosLicitacao = this.anexosLicitacao.filter(doc => doc.tipo !== 'TERMO_DESENTRANHAMENTO')
      const uploadedFiles = this.loki.uploadedFiles

      for (let i = 0; i < uploadedFiles.length; i++) {
        const file = uploadedFiles[i]
        file.arquivoUri = file.uri
        file.arquivoNome = file.name
        file.tipo = this.inferirTipoAnexo(file)
      }

      return anexosLicitacao.concat(uploadedFiles)
    },
    arquivosAceitos() {
      return this.parametros.propriedadesLicitacao.extensao
    },
    deveBloquearEdicaoEdital() {
      return (this.value.numRepeticao && this.value.numRepeticao > 0)
          || this.value.publicado
    },
    ...mapState(['loki', 'licitacao', 'anexosLicitacao', 'parametros'])
  },
  async mounted() {
    this.componentKey++
    this.gerarSoundexParaTiposAnexo()
  },
  methods: {
    ...mapActions([actionTypes.BUSCAR_QTD_PROPOSTAS_POR_LICITACAO]),
    isAceitoPNCP(anexo) {
      if (this.value.amparoLegal && !this.value.amparoLegal.pncp) {
        return true
      }
      const formato = anexo.arquivoNome.split('.').pop()
      return formatosAceitosPncp.includes(formato);
    },
    anexoEstaBloqueado(anexo) {
      return this.anexosBloqueadosAtivarInativar.some(anexoId => anexoId === anexo.id)
    },
    emitirInativarAnexo(anexo) {
      if (this.anexosBloqueadosAtivarInativar.includes(anexo.id)) {
        return
      }
      this.$emit('onInativarAnexo', anexo)
    },
    emitirAtivarAnexo(anexo) {
      if (this.anexosBloqueadosAtivarInativar.includes(anexo.id)) {
        return
      }
      this.$emit('onAtivarAnexo', anexo)
    },
    gerarSoundexParaTiposAnexo() {
      this.tiposAnexo.filter(tipo => !tipo.oculto).forEach(tipo => {
        const soundex = AzSoundex.gerarSoundex(tipo.chave.toLowerCase(), true)
        this.soundexTiposAnexo.push(soundex)
        tipo.soundex = soundex
      })
    },
    inferirTipoAnexo(anexo) {
      const nomeArquivo = this.limparNomeArquivo(anexo.name)
      const soundexNomeArquivo = AzSoundex.gerarSoundex(nomeArquivo.toLowerCase(), true)
      const soundexMaisParecido = AzSoundex.selecionarMaisParecido(this.soundexTiposAnexo, soundexNomeArquivo)
      if (soundexMaisParecido.bestMatch.rating < this.taxaSemelhancaMinimaAceitavelTipoAnexo) {
        return undefined
      }
      const tipoInferido = this.tiposAnexo.filter(tipo => !tipo.oculto).find(tipo => tipo.soundex === soundexMaisParecido.bestMatch.target)
      return tipoInferido.chave
    },
    isSelectTipoHabilitado(item) {
      return !item.id && this.editando
    },
    limparNomeArquivo(nomeAnexo) {
      const nomeSemNumeros = nomeAnexo.replace(/[0-9]/g, '')
      const qtdCaracteresNomeArquivo = nomeSemNumeros.length - Math.abs(nomeSemNumeros.length - nomeSemNumeros.lastIndexOf('.'))
      return nomeSemNumeros.substr(0, qtdCaracteresNomeArquivo)
    },
    retornaDescricaoSituacaoAnexo(situacao) {
      if (situacao === 'ATIVO') {
        return 'Ativo'
      } else {
        return 'Inativo'
      }
    },
    async baixarArquivo(doc) {
      const payload = {
        licitacaoId: this.licitacao.id,
        documentoVirtualizadoId: this.tratarIdVirtualizado(doc.idVirtualizado),
        nomeArquivo: doc.arquivoNome,
        externo: doc.externo,
        uri: doc.arquivoUri
      }
      await this.$store.dispatch(actionTypes.FLOWBEE.BAIXAR_ARQUIVO, payload)
    },

    tratarIdVirtualizado(input) {
      if(!!input && input.includes("Erro inesperado ao integrar com flowbee")) {
        return "Erro inesperado ao integrar com flowbee";
      }

      return input;
    },
    ...mapActions([actionTypes.BUSCAR_QTD_PROPOSTAS_POR_LICITACAO])
  },
  filters: {
    tipoAnexo(tipoAnexoChave) {
      const tipoSelecionado = tiposAnexo.filter(tipo => !tipo.oculto).find(tipoObj => tipoObj.chave === tipoAnexoChave)
      return tipoSelecionado ? tipoSelecionado.label : ''
    }
  }
}
</script>

<style scoped lang="stylus">
  .desativado
    opacity 0.5

  .table-status
    &__error i
      font-size: 18px
      color: #d79641

  @media (max-width: 720px)
    .table-dados-edital

      td:nth-of-type(1):before
        display none

      td:nth-of-type(2):before
        content: "Tipo:"

      td:nth-of-type(3):before
        content: "Data:"

      td:nth-of-type(4):before
        content: "Nome:"

      td:nth-of-type(5):before
        display none

  .coluna-documento-edital
    padding-left 10px !important

  .rodape-espaco
    padding 0 20px 30px 20px
    margin-top 15px
    justify-content space-between
    display flex
    font-size 13px



</style>
